export const STATE_NAME = 'featuredCities' as const;
